import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function HeroSection() {
  return <section id="inicio" className="pt-24 pb-20 md:pt-28 md:pb-32 bg-cream relative overflow-hidden" data-id="element-99">
      {/* Decorative background elements */}
      <div className="absolute top-20 left-10 opacity-50" data-id="element-100">
        <SparkleDecoration size={40} color="#F2A59D" data-id="element-101" />
      </div>
      <div className="absolute bottom-20 right-10 opacity-50" data-id="element-102">
        <SparkleDecoration size={60} color="#E8735A" type="star" data-id="element-103" />
      </div>
      <div className="absolute top-40 right-1/4 opacity-30" data-id="element-104">
        <SparkleDecoration size={30} color="#6B1F2A" data-id="element-105" />
      </div>
      <div className="absolute bottom-40 left-1/4 opacity-20" data-id="element-106">
        <SparkleDecoration size={50} color="#E8735A" type="star" data-id="element-107" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-108">
        <div className="flex flex-col items-center text-center" data-id="element-109">
          {/* Headline */}
          <AnimatedSection className="max-w-4xl mb-10 md:mb-14" data-id="element-110">
            <h1 className="sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-burgundy text-[27px]" data-id="element-111">
              ¿Tus mañanas parecen una batalla campal y tus tardes un caos sin
              fin?
            </h1>
          </AnimatedSection>

          {/* Product Name — above the mockup */}
          <AnimatedSection delay={0.15} className="mb-8 md:mb-10" data-id="element-112">
            <div className="flex flex-col items-center gap-3" data-id="element-113">
              {/* Product name in two lines */}
              <h2 className="text-burgundy font-serif font-black sm:text-4xl md:text-5xl tracking-tight text-center text-[25px] pt-[-10px] pb-[-10px] mt-[-20px] mb-[-20px]" data-id="element-114"></h2>
            </div>
          </AnimatedSection>

          {/* Mockup Image — no background, clean floating */}
          <AnimatedSection delay={0.25} className="w-full max-w-lg md:max-w-xl mb-[-40px] md:mb-[-50px] relative" data-id="element-115">
            <div className="relative" data-id="element-116">
              {/* Sparkle decorations around image */}
              <div className="absolute -top-5 -left-5 md:-top-8 md:-left-8 z-10" data-id="element-117">
                <SparkleDecoration size={36} color="#E8735A" data-id="element-118" />
              </div>
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 z-10" data-id="element-119">
                <SparkleDecoration size={28} color="#F2A59D" type="star" data-id="element-120" />
              </div>
              <div className="absolute top-1/4 -right-6 md:-right-10 z-10" data-id="element-121">
                <SparkleDecoration size={22} color="#6B1F2A" type="star" data-id="element-122" />
              </div>

              {/* Subtle glow behind the image */}
              <div className="absolute inset-0 bg-rose/15 rounded-full scale-75 blur-3xl -z-10" data-id="element-123" />

              {/* Clean mockup image — floating animation */}
              <motion.img src="https://cdn.magicpatterns.com/uploads/iPj1XcWJUutXwbv8yVdHVK/ChatGPT_Image_19_mar_2026,_04_53_35_p.m._-_Editado.png" alt="Mega Pack Mamá Sin Estrés 2026" className="w-full h-auto object-contain drop-shadow-2xl pl-[20px] pr-[20px] mt-[-110px] mb-[-110px]" animate={{
              y: [0, -10, 0],
              rotate: [0, 1, 0, -1, 0]
            }} transition={{
              y: {
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              },
              rotate: {
                duration: 5,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} data-id="element-124" />
            </div>
          </AnimatedSection>

          {/* Contents pill badge — below mockup */}
          <AnimatedSection delay={0.3} className="mb-8 md:mb-10" data-id="element-125">
            <div className="bg-coral text-white font-bold text-sm md:text-base px-6 py-2.5 rounded-full shadow-lg tracking-wide uppercase" data-id="element-126">
              6 Tomos + 6 Bonos + Imprimibles
            </div>
          </AnimatedSection>

          {/* Subheadline */}
          <AnimatedSection delay={0.35} className="max-w-3xl mb-10" data-id="element-127">
            <p className="md:text-xl lg:text-2xl text-coral font-medium text-[16px] mt-[-20px] mb-[-20px]" data-id="element-128">
              Descubrí el sistema que miles de mamás ya usan para recuperar su
              calma y organizar su familia sin ser una súper mamá perfecta.
            </p>
          </AnimatedSection>

          {/* CTA */}
          <AnimatedSection delay={0.45} data-id="element-129">
            <a href="#precio" className="inline-block bg-emerald-500 text-white px-10 py-5 rounded-full font-bold md:text-xl hover:scale-105 transition-transform duration-300 shadow-xl text-[14px]" data-id="element-130">
              QUIERO MI MEGA PACK CON 50% OFF
            </a>
            <motion.div className="mt-5 inline-flex items-center justify-center gap-2 bg-coral/15 border border-coral/30 text-coral font-bold text-sm px-5 py-2 rounded-full" animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-131">
              <span className="text-base" data-id="element-132">⏰</span> Oferta válida solo hoy
            </motion.div>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-2" data-id="element-133">
              <span className="bg-burgundy/10 border border-burgundy/20 text-burgundy font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-134">
                📄 100% PDF
              </span>
              <span className="bg-burgundy/10 border border-burgundy/20 text-burgundy font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-135">
                ⚡ Acceso inmediato
              </span>
              <span className="bg-burgundy/10 border border-burgundy/20 text-burgundy font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-136">
                🛡️ Garantía 7 días
              </span>
              <span className="bg-burgundy/10 border border-burgundy/20 text-burgundy font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-137">
                💳 Mercado Pago
              </span>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}